import { BillStatus } from "@redotech/crdb-enums/billing/bill-status";
import * as z from "zod";

const recentBillSchema = z.object({
  id: z.string(),
  status: z.enum(BillStatus),
  startTime: z.date(),
  endTime: z.date(),
  billedDate: z.date(),
  totalCharged: z.number(),
  currency: z.string(),
  products: z.array(z.string()),
  deferred: z.boolean(),
});

export type RecentBill = z.infer<typeof recentBillSchema>;

export const getTeamRecentBills = {
  name: "getTeamRecentBills" as const,
  input: z.object({
    teamId: z.string(),
    limit: z.number().int().min(1).max(10).default(3),
  }),
  output: z.object({
    returnsBills: z.array(recentBillSchema),
    softwareBills: z.array(recentBillSchema),
  }),
};
